import TimelineDot from '@mui/lab/TimelineDot';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import ShortcutIcon from '@mui/icons-material/Shortcut';
import CircleIcon from '@mui/icons-material/Circle';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import {  Theme } from '@mui/system';
import { HISTORY_EVENT } from '../../../models/eventTypes';
import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline';


interface EventIconProps {
  eventType: HistoryEventType
  isPending: boolean
  isDeclined?: boolean
  isDeactivated?: boolean
}

const EventIcon: React.FC<EventIconProps> = ({ eventType, isPending, isDeclined, isDeactivated }) => {
  if (eventType === HISTORY_EVENT.Approved) {
    return (
      <TimelineDot sx={styles}>
        <ShortcutIcon color="success" />
      </TimelineDot>
    )
  }

  if (eventType === HISTORY_EVENT.Reactivated || eventType === HISTORY_EVENT.Reactivation) {
    return (
      <TimelineDot sx={styles}>
        <TripOriginIcon />
      </TimelineDot>
    )
  }

  if (eventType === HISTORY_EVENT.Deactivation || eventType === HISTORY_EVENT.Deactivated) {
    return (
      <TimelineDot sx={styles}>
        <RemoveCircleOutline sx={{ color: 'common.black' }} />
      </TimelineDot>
    )
  }

  if (eventType === HISTORY_EVENT.Declined) {
    return (
      <TimelineDot sx={styles}>
        <CloseIcon color="error" />
      </TimelineDot>
    )
  }

  if (!isPending && !isDeclined && !isDeactivated) {
    return (
      <TimelineDot sx={styles}>
        <CircleIcon />
      </TimelineDot>
    )
  }

  return (
    <TimelineDot sx={styles}>
      <TripOriginIcon sx={isDeclined ? null : styles.dotAnimation} />
    </TimelineDot>
  )
};

const styles = {
  width: 1,
  height: 1,
  dotAnimation: {
    // respect reduced motion
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
    // tweak the transform origin to avoid visual shift
    transformOrigin: 'center',
  },
  '&.MuiTimelineDot-root': {
    // Reset styles
    borderRadius: 'unset',
    boxShadow: 'unset',
    backgroundColor: 'unset',
    m: 0,
    p: 0,

    // Custom styles
    mt: '2px',
    mb: '8px',
    height: '20px',
    width: '20px',
    color: (t: Theme) => t.palette.grey[400],
    justifyContent: 'center',
    alignItems: 'center',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '18px',
  }
} as const

export default EventIcon;
